import { Box, Container, ContainerOwnProps } from "@mui/material";
import React from "react";

interface PageLayoutProps {
  children: React.ReactNode;
  maxWidth?: ContainerOwnProps["maxWidth"];
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  maxWidth = "xl",
}) => {
  return (
    <Container maxWidth={maxWidth} sx={{ height: "100%" }}>
      <Box sx={{ paddingTop: 4 }}>{children}</Box>
    </Container>
  );
};
